import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// Register service worker for PWA functionality
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log(
      "PWA: Service worker registered successfully. App is now available offline."
    );
  },
  onUpdate: (registration) => {
    console.log("PWA: New content is available. Please refresh to update.");
    // You can add custom logic here to handle updates
    // For example, show a notification to the user
  },
});

// Initialize PWA install prompt
serviceWorkerRegistration.initializePWAInstallPrompt();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
